module.exports = __webpack_public_path__ + "img/test.f8354bb9.jpg";